/* eslint-disable react/prop-types */

import React from 'react';
import { Form } from 'react-bootstrap';

export default function LineChartWigetOptions({ state, onChange }) {
  // const [test, setTest] = useState('');
  // console.log('PROPS.STATE===', props.state);
  // if (!props.state.test) {
  //   props.state.test = '';
  // }

  // Setup defaults
  if (!Object.hasOwn(state,'trendLineShow')) {
    onChange(Object.assign({}, state, { trendLineShow: false }));
  }

  if (!Object.hasOwn(state, 'trendLineExcludeLast')) {
    onChange(Object.assign({}, state, { trendLineExcludeLast: false }));
  }

  return (
    <>
      <Form.Check
        type='checkbox'
        id='defaultCheckbox'
        label='Show Legend'
        checked={state.showLegend}
        onChange={e => {
          onChange(Object.assign({}, state, { showLegend: e.target.checked }))
        }}
      />


<Form.Group controlId="trendlines">
  <Form.Check
        type='checkbox'
        id='defaultCheckbox'
        label='Show Trend Line'
        checked={state.trendLineShow}
        onChange={e => {
          onChange(Object.assign({}, state, { trendLineShow: e.target.checked }))
        }}
      />
      
<Form.Check
        type='checkbox'
        id='trendLineExcludeLast'
        label='Exclude Last Value From Trend Calculation'
        checked={state.trendLineExcludeLast}
        onChange={e => {
          onChange(Object.assign({}, state, { trendLineExcludeLast: e.target.checked }))
        }}
      />
  </Form.Group>

      <Form.Group controlId="selectExample">
        <Form.Label>Point Style</Form.Label>
        <Form.Select label="Point Style" size="sm"
          value={state.pointStyle}
          onChange={e => {onChange(Object.assign({}, state, { pointStyle: e.target.value }))}}
        >
          <option value="none">None</option>
          <option value="circle">Circle</option>
          <option value="cross">Cross</option>
          <option value="crossRot">CrossRot</option>
          <option value="dash">Dash</option>
          <option value="line">Line</option>
          <option value="rect">Rect</option>
          <option value="rectRounded">RectRounded</option>
          <option value="rectRot">RectRot</option>
          <option value="star">Star</option>
          <option value="triangle">Triangle</option>
        </Form.Select>
      </Form.Group>
    </>
  );
}
